/**
 * UTILITAIRES POUR LA GESTION DES ORDRES
 * Centralise toutes les fonctions réutilisables pour les ordres
 */

import { VALIDATION_STATUS } from '../../service/utils/validationStatus';

/**
 * Formate un montant avec séparateur de milliers français
 * @param {number} amount - Montant à formater
 * @returns {string} Montant formaté
 */
export const formatAmount = (amount) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(amount || 0);
};

/**
 * Détermine la classe CSS pour le statut d'un ordre
 * @param {string} status - Statut de l'ordre
 * @returns {string} Classes CSS Bootstrap
 */
export const getStatusClass = (status) => {
  switch (status) {
    // États de succès - Vert
    case 'Completed':
    case 'Approved':
      return 'bg-success bg-opacity-10 text-success border border-success border-opacity-25';
    
    // États d'attente - Orange/Ambre
    case 'Pending':
    case 'PendingValidation':
    case 'PendingExecution':
      return 'bg-warning bg-opacity-10 text-warning-emphasis border border-warning border-opacity-25';
    
    // États d'échec/rejet - Rouge
    case 'Canceled':
    case 'Rejected':
    case 'ValidationRejected':
    case 'Echec Completed':
      return 'bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25';
    
    // État partiel - Bleu
    case 'Partial':
    case 'Partially':
      return 'bg-info bg-opacity-10 text-info-emphasis border border-info border-opacity-25';
    
    // État brouillon - Gris
    case 'Brouillon':
      return 'bg-secondary bg-opacity-10 text-secondary-emphasis border border-secondary border-opacity-25';
    
    // Par défaut
    default:
      return 'bg-light bg-opacity-10 text-light border border-light border-opacity-25';
  }
};

/**
 * Formate le nom du marché pour l'affichage
 * @param {string} marketName - Nom du marché
 * @returns {string} Nom formaté
 */
export const formatMarketName = (marketName) => {
  switch (marketName) {
    case "Public": return "cote";
    case "Private": return "non cote";
    case "Monetary": return "Monetaire";
    default: return marketName || "";
  }
};

/**
 * Vérifie si un ordre peut être modifié
 * @param {Object} order - Ordre à vérifier
 * @returns {boolean} True si modifiable
 */
export const isOrderEditable = (order) => {
  return order.validationStatut !== VALIDATION_STATUS.VALIDATED && 
         order.validationStatut !== VALIDATION_STATUS.EXECUTED;
};

/**
 * Vérifie si un ordre peut être soumis à validation
 * @param {Object} order - Ordre à vérifier
 * @param {string} role - Rôle de l'utilisateur
 * @returns {boolean} True si soumissible
 */
export const canSubmitToValidation = (order, role) => {
  return (order.validationStatut === VALIDATION_STATUS.DRAFT || 
          order.validationStatut === VALIDATION_STATUS.REJECTED) && 
          role === 'manager';
};